import { NgModule } from '@angular/core';
import { SlideMenuComponent } from './slide-menu.component';
import { IonicModule } from '@ionic/angular';
import { AppRoutingModule } from '../../app-routing.module'
import { TranslateModule } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';
import { StorageServicesService } from '../../services/storage_services/storage-services.service';

@NgModule({
    declarations: [SlideMenuComponent],
    exports: [SlideMenuComponent],
    imports: [IonicModule, AppRoutingModule, TranslateModule]

})

export class SlideMenuModule {

    constructor(
        translate: TranslateService,
        private storageService: StorageServicesService,
    ) {
        //translate.use('en');
    }

    ngOnInit() {

    }
}